/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Error_Category_Not_Found1Inputs */

const vi_cmspost_error_category_not_found1 = /** @type {(inputs: Cmspost_Error_Category_Not_Found1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyên mục không còn tồn tại — tải lại trang.`)
};

/**

* @param {Cmspost_Error_Category_Not_Found1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_error_category_not_found1 = /** @type {((inputs?: Cmspost_Error_Category_Not_Found1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Error_Category_Not_Found1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_error_category_not_found1(inputs)
});
export { cmspost_error_category_not_found1 as "cmsPost_error_category_not_found" }